import { useMemo } from "react";

import { useMediaCategoriesSelector } from "./useMediaCategoriesSelector";
import { MediaCategoryType } from "../enums";

export const useMediaGenreListSelector = () => {
  const categories = useMediaCategoriesSelector();
  return useMemo(() => {
    return categories.Entities.filter(
      (item) => item.CategoryTypeCode === MediaCategoryType.Main
    );
  }, [categories]);
};
